import { DateRow, NameRow, PriceRow, TextRow, TextToolTip } from 'components';
import {operationTypesEnum} from "fragments";
import {Images} from 'assets/images';
import {ReactComponent as ProblemSolvingSvg} from "../../../assets/images/svg/ProblemSolvingSvg.svg";
import React from 'react';

const renderButtons = (data, info, load) => {
    return <div className="del-edit-wrapper">
        <button onClick={() => data('edit')}>
            <img src={Images.Edit} alt={'icon'}/>
            <p className="edit-text">Edit</p>
        </button>
        <button onClick={() => data('delete')}>
            <img src={Images.Remove} alt={'icon'}/>
            <p className="delete-text">Delete</p>
        </button>
    </div>;
};

export const ebayHead = [
    { name: '', notSearch: true, custom: false, maxWidth: 60, cellWidth: 60 },
    {name: 'searchRequest', nameRow: 'sku', title: 'eBay SKU', custom: false},
    {name: 'actions', title: 'Actions', custom: false, type: 'notChange'},
];

export const ebayBody = [];


export const ebayOrderHead = [
    {name: 'searchRequest', nameRow: 'orderId', title: ' eBay Order ID', custom: false},
    {name: 'addedDate', title: 'Added Date,Time', custom: false},
    {name: 'createdAt', title: 'Created Date', custom: false},
    {name: 'Status', title: 'Status', custom: false},
    {name: 'actions', title: 'Actions', custom: false, type: 'notChange'},
];

export const ebayOrderBody = [
    {rowText: (item) => <NameRow name={item?.sku}/>, notClickable: true},
    {rowText: (item) => <NameRow big={true} size={20} name={item?.erplyCode}/>, notClickable: true},
    {rowText: (item) => <NameRow name={item?.multiplier}/>, notClickable: true},
    {rowText: (item) => <NameRow name={item?.productType ? item?.productType : 'Not Set'}/>, notClickable: true},
    {button: (item, info, load) => renderButtons(item, info, load), notClickable: true},
];


export const ebayInventoryTransferHead = (operationType) => {
    if (operationType === operationTypesEnum.TRANSFER) {
        return [
            {name: 'transferId', title: 'ID', custom: false},
            {name: 'transferDate', title: 'Date', custom: false},
            {name: 'warehouseFrom', title: 'Warehouse From', custom: false},
            {name: 'warehouseTo', title: 'Warehouse To', custom: false},
            {name: 'qty', title: 'Qty', custom: false},
            {name: 'status', title: 'Status', custom: false, type: 'notChange'},
        ]
    } else {
        return [
            {name: 'transferId', title: 'ID', custom: false},
            {name: 'transferDate', title: 'Date', custom: false},
            {name: 'warehouse', title: 'Warehouse', custom: false},
            {name: 'qty', title: 'Qty', custom: false},
            {name: 'status', title: 'Status', custom: false, type: 'notChange'},
        ]
    }
};

export const ebayInventoryTransferBody = (operationType) => {
    if (operationType === operationTypesEnum.TRANSFER) {
        return [
            {rowText: (item) => <NameRow name={item?.sku}/>, notClickable: true},
            {rowText: (item) => <NameRow big={true} size={20} name={item?.erplyCode}/>, notClickable: true},
            {rowText: (item) => <NameRow name={item?.multiplier}/>, notClickable: true},
            {
                rowText: (item) => <NameRow name={item?.productType ? item?.productType : 'Not Set'}/>,
                notClickable: true
            },
            {button: (item, info, load) => renderButtons(item, info, load), notClickable: true},
        ]
    } else {
        return [
            {rowText: (item) => <NameRow name={item?.sku}/>, notClickable: true},
            {rowText: (item) => <NameRow big={true} size={20} name={item?.erplyCode}/>, notClickable: true},
            {
                rowText: (item) => <NameRow name={item?.warehouse ? item?.warehouse : 'Not Set'}/>,
                notClickable: true
            },
            {button: (item, info, load) => renderButtons(item, info, load), notClickable: true},
        ]
    }
};

export const ebayErrorsHead = [
    {name: 'createdAt', title: ' Date', type: 'date', custom: true},
    {name: 'message', title: 'Message', custom: false},
    {name: 'actions', title: 'Actions', custom: false, type: 'notChange'},
];

export const ebayErrorsBody = (onClick) => {
    return [
        {rowText: (item) => <DateRow date={item?.createdAt}/>, width: '15%'},
        {
            rowText: (item) => <TextToolTip text={item?.message} content={item?.message}/>,
            notClickable: true,
            width: '70%'
        },
        {
            button: (item, info, load) => (
                <div
                    style={{display: 'flex', alignItems: 'center', gap: '8px', width: '15%'}}
                    onClick={() => onClick(info)}
                >
                    <ProblemSolvingSvg/>
                    <p style={{
                        fontSize: '14',
                        fontWeight: '600',
                        textDecoration: 'underline',
                        color: '#BA43B1'
                    }}>Resolve</p>
                </div>
            ),
        }
    ]
}


export const ebayPriceErrorsHead = [
    { name: 'createdAt', title: 'Date', type: 'date', custom: true },
    { name: 'sku', title: 'SKU', custom: false },
    { name: 'price', title: 'Price', custom: false },
    { name: 'message', title: 'Message', custom: false },
];

export const ebayPriceErrorsBody = [
    { rowText: (item) => <DateRow date={item?.createdAt} />, width: '15%' },
    { rowText: (item) => <TextRow name={item?.sku} />, width: '15%' },
    { rowText: (item) => <PriceRow info={item?.price} />, width: '15%' },
    {
        rowText: (item) => <TextToolTip text={item?.message} content={item?.message} />,
        notClickable: true,
        width: '55%',
    },
];

